import React from 'react'
import { graphql, Link } from 'gatsby'
import SEO from '../components/SEO'
import Layout from '../components/layout'
import { Container, Row, Col, ListGroup } from 'react-bootstrap'

export default ({ data }) => {
  return (
    <Layout>
      <SEO title='議員紹介'/>
      <Container fluid>
        <Row>
          <Col>
            <h4>現職議員</h4>
          </Col>
        </Row>
        <Row>
          <Col>
            <ListGroup variant='flush'> 
              {data.allGiinsYaml.edges.filter(({ node }) => { return node.fields.current; }).map(({ node }) => (
                <ListGroup.Item key={node.identifier}><Link to={`/giins/${node.identifier}`}>{node.name}</Link></ListGroup.Item>
              ))}
            </ListGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <h4>過去</h4>
          </Col>
        </Row>
        <Row>
          <Col>
            <ListGroup variant='flush'>
              {data.allGiinsYaml.edges.filter(({ node }) => { return !node.fields.current; }).map(({ node }) => (
                <ListGroup.Item key={node.identifier}><Link to={`/giins/${node.identifier}`}>{node.name}</Link></ListGroup.Item>
              ))}
            </ListGroup>
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export const query = graphql`
  query {
    allGiinsYaml(sort: { fields: [reading], order: ASC }) {
      edges {
        node {
          fields {
            current
          }
          identifier
          name 
        }
      }
    }
  }
`
